"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

/**
 * @figma designed by Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=13%3A620))
 * @trackcomponent
 * @lastsynced 2025-07-08T18:42:24.612Z
 * @optimized using svgo:^3.0.2
 */
export const Korea = createSVGIcon(
  <>
    <path
      d="M8.867 9.981C7.283 9.981 6 8.642 6 6.991S7.283 4 8.867 4c-1.473.853.166 2.077.955 2.99.363.42.504 1.024.717 1.247.178.185-.133.418-.334.696l-.144.3c-.239.748-.886.812-1.194.748"
      fill="#B64343"
    />
    <path
      d="M9.133 4.019c1.584 0 2.867 1.339 2.867 2.99S10.717 10 9.133 10c2.39-3.24-.28-3.282-.955-3.987-.239-.25-.314-.834-.239-1.246a1.02 1.02 0 0 1 1.194-.748"
      fill="#354992"
    />
    <path stroke="#757575" d="M1 1H17V13H1z" />
    <path
      d="m13.354 2.646 2 2m-10.708-2-2 2m10.708 6.708 2-2m-10.708 2-2-2"
      stroke="#757575"
      strokeDasharray="2 2"
    />
  </>,
  "Korea",
  (strictLocalize) => ({
    viewBox: "0 0 18 14",
    fill: "none",
    titleAccess: strictLocalize({
      id: "GtY8p4",
      defaultMessage: "Korea flag",
      description: { text: "The label for the Korea flag icon" },
    }),
  })
);
